import React from "react"
import { ConfirmSignIn } from "aws-amplify-react"
import { I18n } from "@aws-amplify/core"

import Heading from "../Heading/Heading"


export class ArchieConfirmSignIn extends ConfirmSignIn {
  constructor(props) {
    super(props)
    this._validAuthStates = ["confirmSignIn"]
  }

  showComponent() {
    return (
      <div className="auth__signin">
        <Heading level={2} modifiers={["minor"]}>Confirm MFA Code (SMS)</Heading>

        <form className="auth__form form" onSubmit={this.confirm} method="POST">
          <div className="field">
            <label
              className="field__label"
              htmlFor="code"
            >
              {I18n.get("Code")}
            </label>
            <input
              id="code"
              key="code"
              name="code"
              autoFocus
              autoComplete="off"
              placeholder={I18n.get("Code")}
              className="field__input"
              required
              onChange={this.handleInputChange}
              type="text"
            />
          </div>

          <button className="button button--large" type="submit">
            {I18n.get("Confirm")}
          </button>
          <a
            className="link"
            onClick={() => super.changeState("signIn")}
          >
            Back to Sign in
          </a>
        </form>
      </div>
    )
  }
}


export default ArchieConfirmSignIn
